<script lang="ts">
	import { isSuperformSubmitting } from '$lib/client/utils';
	import { navigating } from '$app/stores';
	import Loader from './Loader.svelte';

	export let show: boolean | undefined = undefined;

	$: shouldShowNavigationOverlay = show ?? (!!$navigating || $isSuperformSubmitting);
</script>

{#if shouldShowNavigationOverlay}
	<span class="-navigation-overlay" />
	<span class="-container">
		<Loader />
	</span>
{/if}

<style lang="scss">
	@import '$lib/styles/variables';

	.-navigation-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: var(--color-bg);
		opacity: 0.5;
		z-index: 1000;

		& :global(*) {
			pointer-events: none;
		}
	}

	.-container {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 1001;

		& :global(*) {
			position: relative;
			left: -50%;
			font-size: 0.5rem;
		}
	}
</style>
